var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"smarttable-view-container"}},[_c('UISelectBox',{attrs:{"id":"report-type","options":_vm.viewModes,"lightTheme":""},model:{value:(_vm.dataViewMode),callback:function ($$v) {_vm.dataViewMode=$$v},expression:"dataViewMode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }